export default [
  [
    "user",
    "",
    ["read"],
    {
      crud: {
        read: {
          auth: "isLogin",
        },
      },
    },
  ],
];
